import CouponList from '@/components/Fiscal/Coupon/CouponList';
import {
  CompaniesInfiniteSelectField,
  DefaultRouteTabs,
  FloatingFormItem,
} from '@/components/_common';
import { TaxCouponListRequest } from '@/core/domain/coupon/coupons/coupons.types';
import { useDebounce } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { convertParams, usePersistSearchParams } from '@/utils/queryParams';
import { Col, Form, Row } from 'antd';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function CouponsPage({ route }: PageProps) {
  const intl = useIntl();

  const [form] = Form.useForm<TaxCouponListRequest>();

  const [queryParams, setQueryParams] = useState<TaxCouponListRequest>({
    ...convertParams<TaxCouponListRequest>({
      companyId: 'number',
    }),
  });

  const queryDebounce = useDebounce(queryParams, 500);
  usePersistSearchParams(queryDebounce);

  useEffect(() => {
    if (queryParams) {
      form.setFieldsValue(queryParams);
    }
  }, [queryParams]);

  const newRoute = {
    ...route,
    routes: [route],
  };

  return (
    <DefaultRouteTabs
      route={newRoute}
      persistSearchParams={false}
      permissions={route.permissions}
    >
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <Form form={form}>
        <Row style={{ marginBottom: 24 }}>
          <Col span={24} sm={6}>
            <FloatingFormItem
              label="Empresa"
              name="companyId"
              getValueFromEvent={(value) => {
                setQueryParams((prev) => ({ ...prev, companyId: value }));
                return value;
              }}
              initialValue={queryParams.companyId}
            >
              <CompaniesInfiniteSelectField
                queryEnable
                selectFirst={!queryParams?.companyId}
              />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>

      <CouponList queryParams={queryParams} />
    </DefaultRouteTabs>
  );
}
